import { PageShell, Block } from "./PageShell";
import { BRAND } from "../data/content";

export default function Terms() {
  return (
    <PageShell
      title="Terms of Use"
      intro="Welcome to HEARD. By joining our beta and using HEARD, you agree to these simple, good-faith terms."
    >
      <Block heading="A community, used kindly">
        <p>HEARD is a supportive community. You agree to participate with empathy and to follow our Community Guidelines. We may remove content or access that puts the safety or warmth of the community at risk.</p>
      </Block>
      <Block heading="Not medical or crisis care">
        <p>HEARD offers peer support, not professional, medical, or emergency services. If you are in crisis, please use the resources in our Support Center or contact your local emergency number.</p>
      </Block>
      <Block heading="Your content">
        <p>You keep ownership of what you share. By posting, you allow HEARD to display your content within the community so others can support you. Please only share what you're comfortable sharing.</p>
      </Block>
      <Block heading="Beta software">
        <p>HEARD is in active development. Features may change, and occasional issues may occur. We're grateful for your patience and feedback as we build.</p>
      </Block>
      <Block heading="Contact">
        <p>Questions about these terms? Reach us at <a className="text-sage-deep underline" href={`mailto:${BRAND.email}`}>{BRAND.email}</a>.</p>
      </Block>
      <p className="text-sm text-ink/50">These beta terms will be expanded before public launch.</p>
    </PageShell>
  );
}
